import { ChangeEvent, forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react";
import { IDoesFilterPassParams, IFilterParams } from "ag-grid-community";
import { OptionObj } from "@/types/interfaces/common";

interface Props extends IFilterParams {
  options: OptionObj[];
  partialMatch?: boolean;
  /** the server filters, as with RemoteTextFilter: the grid holds one already-filtered page */
  remote?: boolean;
}

const SelectFilter = forwardRef(({ options, ...props }: Props, ref) => {
  const [filterState, setFilterState] = useState(options[0].value);

  useImperativeHandle(ref, () => {
    return {
      isFilterActive() {
        return filterState !== "";
      },
      doesFilterPass(params: IDoesFilterPassParams) {
        if (props.remote) return true;

        const { data } = params;
        const field = props.colDef.field! || props.colDef.colId!;

        let fieldValue = field.split(".").reduce((obj, key) => obj?.[key], data);

        if (props.partialMatch) {
          return fieldValue && String(fieldValue).includes(filterState);
        }

        if (typeof fieldValue === "boolean") {
          fieldValue = fieldValue ? "true" : "false";
        }

        return filterState == fieldValue;
      },
      getModel() {
        if (filterState === "") {
          return undefined;
        }

        return {
          state: filterState,
        };
      },
      setModel(model: any) {
        if (model === null) {
          setFilterState("");
        } else {
          setFilterState(model.state);
        }
      },
      setValue(value: string) {
        setFilterState(value);
      },
    };
  });

  const handleChange = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
    setFilterState(e.target.value || "");
  }, []);

  useEffect(() => props.filterChangedCallback(), [filterState]);

  return (
    <div
      style={{
        background: "#F0F4F8",
        padding: "8px",
      }}
    >
      <span>Select Filter</span>
      <select
        style={{
          width: "100%",
          height: 32,
          marginTop: "8px",
          borderRadius: "var(--ag-border-radius)",
          border: "var(--ag-borders-input) var(--ag-input-border-color)",
          padding: 2,
          outline: "none",
        }}
        defaultValue={filterState}
        value={filterState}
        onChange={handleChange}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
});
export default SelectFilter;
